export default __webpack_public_path__ + "c31ba8e0bd53f6d1bfcf0b30b0e559ae.png";